import React, { Component } from 'react'
import axios from "axios";
import Path from "./config";
import { Link } from "react-router-dom";
export class ShowSuchiList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sbg_list: [],
            sbg_list1: [],
            search: '',
            sbg_id_sr: "",
            sbg_first_name_sr: '',
            sbg_middle_name_sr: '',
            sbg_sirname_sr: '',
            sbg_mobile_no_sr: '',
            sbg_password_sr: '',
            sbg_registraion_date_sr: '',
            sbg_photo_sr: ''
        }

    }

    componentDidMount() {

        this.setState({

            admin: localStorage.getItem("admin"),
            adminid: localStorage.getItem("adminid")
        })



        axios.get(Path + 'Show_bride_groom_suchi_list.php?sbg_admin_login_id=' + localStorage.getItem("adminid"))
            .then(function (response) {
                // handle success
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ sbg_list: response.data.bg_gotra })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });



    }
    searchValue = (e) => {
        this.setState({
            search: e.target.value
        })
    }
    SearchResult = (e) => {

        //e.preventDefault();
        axios.get(Path + 'Show_bride_groom_search.php?sbg_mobile_no=' + this.state.search)
            .then(function (response) {
                alert(response.sbg_id)
                // handle success
                //  console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                response = response.data;
                let photopath = Path + response.sbg_photo;
                this.setState({
                    // sbg_list1:response.data.bg_gotra
                    sbg_id_sr: response.sbg_id,
                    sbg_first_name_sr: response.sbg_first_name,
                    sbg_middle_name_sr: response.sbg_middle_name,
                    sbg_sirname_sr: response.sbg_last_name,
                    sbg_mobile_no_sr: response.sbg_mobile_no,
                    sbg_password_sr: response.sbg_password,
                    sbg_registraion_date_sr: response.sbg_registraion_date,
                    sbg_photo_sr: photopath
                })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
    }

    render() {
        let renderTableData =
            this.state.sbg_list.map((slist, index) => {
                const { sbg_id, sbg_mobile_no, sbg_first_name, sbg_middle_name, sbg_last_name, sbg_photo, sbg_password, sbg_registraion_date } = slist //destructuring
                let photopath = Path + sbg_photo;
                return (
                    <tr key={sbg_id}>
                        <td>{sbg_id}</td>
                        <td>{sbg_first_name} {sbg_middle_name} {sbg_last_name}</td>
                        <td>{sbg_mobile_no}</td>
                        <td>{sbg_password}</td>
                        <td>{sbg_registraion_date}</td>
                        <td>
                            <a href={photopath} target="_blank" rel="noreferrer">
                                <img src={photopath} alt="Leva" height="50" /></a></td>


                        <td>
                            <Link to={`/AdminProfile/FullbiodataAdminedit/${sbg_id}`} className="text-warning font-weight-bold">
                                Edit
                            </Link>
                        </td>
                        <td>
                        </td>
                    </tr>
                )
            })


        return (
            <>
                <div className="container mt-5">
                    <input type="search" className="form-text p-2" value={this.state.search} onChange={this.searchValue} placeholder="Enter Registered Mobile No." />
                    &nbsp; <button className="btn-danger p-1" onClick={() => this.SearchResult()}>Search</button>
                </div>
                <table class="table table-striped table-hover " width="100%" >
                    <thead>
                        <tr>
                            <th scope="col">SuchiId </th>
                            <th scope="col">Name</th>
                            <th scope="col">Mobile No.</th>
                            <th scope="col">Password</th>
                            <th scope="col">Registration Date</th>
                            <th scope="col">Photo</th>
                            <th scope="col">Action</th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td>{this.state.sbg_id_sr}</td>
                            <td>{this.state.sbg_first_name_sr} {this.state.sbg_middle_name_sr} {this.state.sbg_sirname_sr}</td>
                            <td>{this.state.sbg_mobile_no_sr}</td>
                            <td>{this.state.sbg_password_sr}</td>
                            <td>{this.state.sbg_registraion_date_sr}</td>
                            <td><img src={this.state.sbg_photo_sr} alt="Leva" height="50" /></td>
                            <td>
                                <Link to={`/AdminProfile/FullbiodataAdminedit/${this.state.sbg_id_sr}`} className="text-warning font-weight-bold">
                                    Edit
                                </Link>
                            </td>
                            <td>
                            </td>
                        </tr>
                        {renderTableData}


                    </tbody>
                </table>
            </>
        )
    }
}

export default ShowSuchiList
